import { string, bool, object, oneOfType, arrayOf } from 'prop-types';

/**
 * The component's prop types.
 * @type {Object}
 */
export default {
    k: oneOfType([
        string,
        arrayOf(string)
    ]).isRequired,
    params: object,
    parseMarkup: bool
};
